import { AbstractQuery } from 'src/models/query';

const COMPLETE_LIST_EXPORT_IDENTIFIER_SUFFIX = '#completeListExport';

export const COMPLETE_LIST_EXPORT_LIMIT_HEADROOM = 50;

export const prepareQueryForCompleteListExport = <QueryType extends AbstractQuery>(query: QueryType): QueryType => {
	const baseUniqueQueryIdentifier = query.uniqueQueryIdentifier.bind(query);

	query.uniqueQueryIdentifier = (): string =>
		`${baseUniqueQueryIdentifier()}${COMPLETE_LIST_EXPORT_IDENTIFIER_SUFFIX}`;
	(query as unknown as { subscribeForUpdates: boolean }).subscribeForUpdates = false;

	return query;
};
